export default "__VITE_ASSET__Dz6bim9g__"